import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrders } from '../../../store/orders/orderReducer'; // Assuming this action is defined
import Spinner from '../../../components/Spinner/Index';
import { ArrowDownCircleIcon, ArrowUpCircleIcon } from '@heroicons/react/20/solid';

const statuses = {
    Paid: 'text-green-700 bg-green-50 ring-green-600/20',
    Pending: 'text-yellow-700 bg-yellow-50 ring-yellow-600/20',
    Failed: 'text-red-700 bg-red-50 ring-red-600/20',
};

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

const OrdersPage = () => {
    const dispatch = useDispatch();
    const { orders, isLoading, isError, message } = useSelector((state) => state.orders);
    const token = useSelector((state) => state.auth.token);

    useEffect(() => {
        if (token) {
            dispatch(fetchOrders(token)); // Fetch all orders for the logged-in user
        }
    }, [dispatch, token]);

    if (isLoading) {
        return <Spinner />;
    }

    if (!orders || orders.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <h2 className="text-2xl font-bold text-gray-800">You haven't placed any orders yet</h2>
                <p className="mt-2 text-sm text-gray-500">
                    Explore our shop and start your journey with our amazing products.
                </p>
                <a
                    href="/user/shop"
                    className="mt-6 inline-block rounded-lg bg-green-600 px-3 py-2 text-base font-medium text-white shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
                >
                    Browse the Shop
                </a>
            </div>
        );
    }


    return (
        <div>
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <h2 className="mx-auto max-w-2xl text-base font-semibold text-gray-900 lg:mx-0 lg:max-w-none">
                    My Orders
                </h2>
            </div>
            <div className="mt-6 overflow-hidden border-t border-gray-100">
                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                    <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
                        <table className="w-full text-left">
                            <thead>
                                <tr>
                                    <th className="py-3 text-sm font-medium text-gray-900">Date</th>
                                    <th className="py-3 text-sm font-medium text-gray-900">Total</th>
                                    <th className="py-3 text-sm font-medium text-gray-900">Payment Status</th>
                                    <th className="py-3 text-sm font-medium text-gray-900">Business</th>
                                    <th className="py-3 text-sm font-medium text-gray-900">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orders.map((order) => {
                                    const businessNames = [
                                        ...new Set(order.items.map((item) => item.businessId?.businessInformation?.businessName || 'N/A')),
                                    ].join(', ');

                                    return (
                                        <tr key={order._id} className="border-t border-gray-200">
                                            <td className="py-4 text-sm text-gray-500">
                                                {new Date(order.createdAt).toLocaleDateString()}
                                            </td>
                                            <td className="py-4 text-sm text-gray-900">
                                                ${order.totalAmount.toFixed(2)}
                                            </td>
                                            <td className="py-4">
                                                <span
                                                    className={classNames(
                                                        statuses[order.paymentStatus] || 'text-gray-700 bg-gray-50',
                                                        'rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset'
                                                    )}
                                                >
                                                    {order.paymentStatus}
                                                </span>
                                            </td>
                                            <td className="py-4 text-sm text-gray-500">
                                                {businessNames}
                                            </td>
                                            <td className="py-4 text-right text-sm font-medium">
                                                <a
                                                    href={`/user/orders/${order._id}`}
                                                    className="text-green-600 hover:text-green-900"
                                                >
                                                    View Details
                                                </a>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrdersPage;
